window.addEventListener('load', function () {
  const alertBar = document.querySelector('.alert-bar');
  const closeButton = document.querySelector('.alert-bar__close');
  const newsList = document.querySelector('.alert-bar__slides');
  const newsItems = newsList.getElementsByTagName('li');
  let currentItemIndex = 0;

  // Check if alertBar should be hidden
  const hideUntil = localStorage.getItem('hideUntil');
  if (hideUntil && new Date().getTime() < hideUntil) {
    alertBar.style.display = 'none';
  }

  // Cycle through news items
  const cycleNewsItems = () => {
    newsItems[currentItemIndex].classList.add('fade');
    setTimeout(() => {
      newsItems[currentItemIndex].classList.remove('active');
      newsItems[currentItemIndex].classList.remove('fade');
      currentItemIndex = (currentItemIndex + 1) % newsItems.length;
      newsItems[currentItemIndex].classList.add('active');
    }, 500);
  };

  // Start cycling through news items every 3 seconds
  const cycleInterval = setInterval(cycleNewsItems, 3000);

  // Add click listener to close button
  closeButton.addEventListener('click', () => {
    // Hide alert bar
    alertBar.style.display = 'none';
    // Store timestamp to local storage for 1 hour
    const now = new Date().getTime();
    const hideUntil = now + 60 * 1000;
    localStorage.setItem('hideUntil', hideUntil);
  });
});
